import LivrosCarousel from '../../../../../componentes/js/LivrosCarrossel';

const LivrosSection = ({ steps, livros }) => (
  <section className="livros">
      <h2>Livros</h2>
      <div className='containerLivros' style={{display: "flex"}}>
        <div className='informacoesLivros'>
          {steps.map((step) => (
            <div
              key={step.number}
              className="step"
              style={{ backgroundColor: step.color + "22" }}
            >
              {step.logo && (
                <div className="school-logo">
                  <span className="logo-text">{step.logo.text}</span>
                  <img
                    src={step.logo.url}
                    alt="Logo da escola"
                    className="logo-img"
                  />
                </div>
              )}
              <div
                className="step-icon"
                style={{ backgroundColor: step.color }}
              >
                <img
                  src={step.icon}
                  alt={`Ícone etapa ${step.number}`}
                  width="30"
                  height="30"
                />
              </div>
              <div className="step-content">
                <h2 style={{ color: step.color }}>
                  {step.number}. {step.title}
                </h2>
                <p>{step.description}</p>
              </div>
            </div>
          ))}
          <button style={{fontSize: '4vh'}}><a href="https://educarlivros.com/escola" target='_blank'>Comprar agora</a></button>
        </div>
        <LivrosCarousel livros={livros}/>
      </div>
  </section>
);

export default LivrosSection;
